import { useDynamicContext } from "@dynamic-labs/sdk-react-core";

import Loader from "../components/loader/loader";

const DynamicGate = ({ children }: any) => {
  const { sdkHasLoaded } = useDynamicContext();

  // Prevent routing until session restored
  if (!sdkHasLoaded) {
    return <Loader />;
  }

  return children;
};

export default DynamicGate;
